<template>
  <div class="login-container">
    <div class="login-box">
      <h2 class="login-title">系统登录</h2>
      
      <el-form 
        ref="loginForm" 
        :model="formData" 
        :rules="rules" 
        class="login-form"
      >
        <!-- 用户名 -->
        <el-form-item prop="username">
          <el-input 
            v-model="formData.username" 
            placeholder="用户名" 
            prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>
        
        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input 
            v-model="formData.password" 
            :type="showPassword ? 'text' : 'password'" 
            placeholder="密码" 
            prefix-icon="el-icon-lock"
          >
            <template slot="suffix">
              <i 
                :class="showPassword ? 'el-icon-eye-slash' : 'el-icon-eye'" 
                @click="togglePassword"
                style="cursor: pointer"
              ></i>
            </template>
          </el-input>
        </el-form-item>
        
        <!-- 验证码 -->
        <el-form-item prop="code">
          <div class="captcha-group">
            <el-input 
              v-model="formData.code" 
              placeholder="验证码" 
              prefix-icon="el-icon-shield"
              class="captcha-input"
            ></el-input>
            <img 
              :src="captchaImage" 
              alt="验证码" 
              class="captcha-img"
              @click="getCaptcha"
              v-loading="isCaptchaLoading"
            >
          </div>
        </el-form-item>
        
        <!-- 登录按钮 -->
        <el-form-item>
          <el-button 
            type="primary" 
            class="login-btn" 
            :loading="isLoading"
            @click="handleLogin"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
      
      <!-- 错误提示 -->
      <el-alert 
        v-if="errorMessage" 
        :message="errorMessage" 
        type="error" 
        show-icon 
        class="error-alert"
        :closable="false"
      ></el-alert>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'Login',
  data() {
    return {
      formData: {
        username: '',
        password: '',
        code: '',
        key: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      showPassword: false,
      captchaImage: '',
      isCaptchaLoading: false,
      isLoading: false,
      errorMessage: ''
    }
  },
  mounted() {
    this.getCaptcha();
  },
  methods: {
    // 获取验证码
    getCaptcha() {
      this.isCaptchaLoading = true;
      this.errorMessage = '';
      
      // 使用环境变量代替硬编码URL
      axios.get(`${process.env.VUE_APP_API_ADMIN_BASE_URL}/admin/user/code`)
        .then(response => {
          if (response.data.code === 200) {
            this.captchaImage = response.data.data.code;
            this.formData.key = response.data.data.key;
          } else {
            this.errorMessage = '获取验证码失败';
          }
        })
        .catch(() => {
          this.errorMessage = '获取验证码失败，请重试';
        })
        .finally(() => {
          this.isCaptchaLoading = false;
        });
    },
    
    // 切换密码显示
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    
    // 登录处理
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.isLoading = true;
          this.errorMessage = '';
          
          // 使用环境变量代替硬编码URL
          axios.post(`${process.env.VUE_APP_API_ADMIN_BASE_URL}/admin/user/login`, this.formData)
            .then(response => {
              if (response.data.code === 200) {
                // 登录成功处理 - 添加成功提示
                this.$message.success('登录成功！');
                localStorage.setItem('token', response.data.data.jwt);
                this.$router.push('/table');
              } else {
                this.errorMessage = response.data.message || '登录失败';
                this.getCaptcha();
              }
            })
            .catch(() => {
              this.errorMessage = '登录请求失败';
              this.getCaptcha();
            })
            .finally(() => {
              this.isLoading = false;
              this.formData.code = '';
            });
        }
      });
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
  padding: 20px;
}

.login-box {
  width: 100%;
  max-width: 360px;
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.login-title {
  text-align: center;
  margin-bottom: 25px;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.login-form {
  width: 100%;
}

/* 解决Element UI默认样式问题 */
::v-deep .el-form-item {
  margin-bottom: 18px;
}

::v-deep .el-input__inner {
  height: 42px;
  border-radius: 4px;
}

/* 验证码区域 */
.captcha-group {
  display: flex;
  gap: 10px;
}

.captcha-input {
  flex: 1;
}

.captcha-img {
  width: 120px;
  height: 42px;
  border-radius: 4px;
  cursor: pointer;
  object-fit: cover;
  border: 1px solid #dcdfe6;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 42px;
  font-size: 16px;
}

/* 错误提示 */
.error-alert {
  margin-top: 15px;
  font-size: 14px;
}
</style>
